(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compact-product-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sku-bundle-showcase-v4')) {
    customElements.define(
      'sku-bundle-showcase-v4',
      class BundleShowcase extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-bundle-submit]');
          this.status = this.querySelector('[data-bundle-status]');
          this.summary = this.querySelector('[data-bundle-summary]');
          this.total = this.querySelector('[data-bundle-total]');
          this.variants = this.readJson('[data-product-variants]');
          this.skuContent = this.readJson('[data-sku-content]');
          this.defaultContent = this.readJson('[data-default-content]');
          this.currentVariantId = Number(this.dataset.currentVariantId || 0);
          this.discountProgress = this.querySelector('[data-discount-progress]');
          this.discountMessage = this.querySelector('[data-discount-message]');
          this.discountBadge = this.querySelector('[data-discount-badge]');
          this.discountFill = this.querySelector('[data-discount-fill]');
          this.discountThreshold = Math.max(1, Number(this.dataset.discountThreshold || 3));
          this.discountPercent = Math.max(0, Number(this.dataset.discountPercent || 0));

          this.handleDocumentChange = (event) => {
            if (this.contains(event.target)) return;
            window.setTimeout(() => this.syncCurrentVariant(), 0);
            window.setTimeout(() => this.syncCurrentVariant(), 120);
          };
          this.handleVariantEvent = (event) => {
            const variantId = Number(event.detail?.variant?.id || event.detail?.id || 0);
            if (variantId) this.setCurrentVariant(variantId);
            else this.syncCurrentVariant();
          };
          this.handlePopState = () => this.syncCurrentVariant();

          this.querySelectorAll('select[data-variant-input]').forEach((select) => {
            select.addEventListener('change', () => {
              this.updateVariantPrice(select);
              this.updateSummary();
            });
          });

          this.querySelectorAll('[data-addon-toggle]').forEach((toggle) => {
            toggle.addEventListener('change', () => {
              toggle.closest('[data-bundle-item]')?.classList.toggle('is-selected', toggle.checked);
              this.updateSummary();
            });
          });

          this.initGalleries();

          if (this.button) {
            this.button.addEventListener('click', () => this.addBundle());
          }

          document.addEventListener('change', this.handleDocumentChange);
          document.addEventListener('variant:change', this.handleVariantEvent);
          document.addEventListener('variant:changed', this.handleVariantEvent);
          document.addEventListener('product:variant-change', this.handleVariantEvent);
          window.addEventListener('popstate', this.handlePopState);

          this.syncCurrentVariant();
          this.updateSummary();
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.handleDocumentChange);
          document.removeEventListener('variant:change', this.handleVariantEvent);
          document.removeEventListener('variant:changed', this.handleVariantEvent);
          document.removeEventListener('product:variant-change', this.handleVariantEvent);
          window.removeEventListener('popstate', this.handlePopState);
        }

        readJson(selector) {
          try {
            return JSON.parse(this.querySelector(selector)?.textContent || '[]');
          } catch (error) {
            return [];
          }
        }

        initGalleries() {
          this.querySelectorAll('[data-card-gallery]').forEach((gallery) => {
            gallery.dataset.galleryIndex = '0';
            gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => {
              this.showGallerySlide(gallery, Number(gallery.dataset.galleryIndex || 0) - 1);
            });
            gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
              this.showGallerySlide(gallery, Number(gallery.dataset.galleryIndex || 0) + 1);
            });
            gallery.querySelectorAll('[data-gallery-dot]').forEach((dot) => {
              dot.addEventListener('click', () => {
                this.showGallerySlide(gallery, Number(dot.dataset.galleryDot || 0));
              });
            });
          });
        }

        showGallerySlide(gallery, requestedIndex) {
          const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
          if (slides.length < 2) return;

          const index = (requestedIndex + slides.length) % slides.length;
          gallery.dataset.galleryIndex = String(index);
          slides.forEach((slide, slideIndex) => {
            slide.hidden = slideIndex !== index;
          });
          gallery.querySelectorAll('[data-gallery-dot]').forEach((dot, dotIndex) => {
            const isActive = dotIndex === index;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        syncCurrentVariant() {
          const urlVariantId = Number(new URL(window.location.href).searchParams.get('variant') || 0);
          const validIds = new Set(this.variants.map((variant) => Number(variant.id)));
          const formInputs = Array.from(document.querySelectorAll('form[action*="/cart/add"] [name="id"]'))
            .filter((input) => !this.contains(input) && validIds.has(Number(input.value)));
          const visibleInput = formInputs.find((input) => input.offsetParent !== null);
          const formVariantId = Number((visibleInput || formInputs[0])?.value || 0);
          const variantId = validIds.has(formVariantId)
            ? formVariantId
            : validIds.has(urlVariantId)
              ? urlVariantId
              : this.currentVariantId;

          this.setCurrentVariant(variantId);
        }

        setCurrentVariant(variantId) {
          const variant = this.variants.find((item) => Number(item.id) === Number(variantId));
          if (!variant) return;

          this.currentVariantId = Number(variant.id);
          this.dataset.currentVariantId = String(variant.id);
          if (this.button) this.button.disabled = !variant.available;

          const skuKey = String(variant.sku || '').trim().toLowerCase();
          const titleKey = String(variant.title || '').trim().toLowerCase();
          const content = this.skuContent.find((item) => {
            const match = String(item.match || '').trim().toLowerCase();
            return match && (skuKey === match || titleKey.includes(match));
          });

          this.updateHero(variant, content);
          this.updateSummary();
        }

        updateHero(variant, content) {
          const image = this.querySelector('[data-sku-image]');
          const picture = this.querySelector('[data-sku-picture]');
          const source = this.querySelector('[data-sku-mobile-source]');
          const placeholder = this.querySelector('[data-sku-placeholder]');
          const desktopImage = content?.desktopImage || variant.image || this.defaultContent.desktopImage || image?.getAttribute('src') || '';
          const mobileImage = content?.mobileImage || content?.desktopImage || variant.image || this.defaultContent.mobileImage || desktopImage;

          if (image && desktopImage) {
            image.src = desktopImage;
            image.srcset = '';
            image.alt = content?.imageAlt || variant.imageAlt || this.defaultContent.imageAlt || variant.title;
            image.hidden = false;
            picture.hidden = false;
            placeholder.hidden = true;
          }
          if (source) source.srcset = mobileImage || desktopImage;

          this.setHtml('[data-sku-eyebrow]', content?.eyebrow || this.defaultContent.eyebrow);
          this.setHtml('[data-sku-heading]', content?.heading || this.defaultContent.heading || variant.title);
          this.setHtml('[data-sku-description]', content?.description || this.defaultContent.description);

          const price = this.querySelector('[data-base-price]');
          if (price) price.textContent = variant.formattedPrice;
        }

        setHtml(selector, value) {
          const element = this.querySelector(selector);
          if (!element) return;
          if (value) {
            element.innerHTML = value;
            element.hidden = false;
          } else {
            element.hidden = true;
          }
        }

        updateVariantPrice(select) {
          const option = select.options[select.selectedIndex];
          const card = select.closest('[data-bundle-item]');
          const price = card.querySelector('[data-current-price]');
          const comparePrice = card.querySelector('[data-compare-price]');

          if (price) {
            price.textContent = option.dataset.price;
          }

          if (comparePrice) {
            comparePrice.textContent = option.dataset.comparePrice;
            comparePrice.hidden = option.dataset.onSale !== 'true';
          }
        }

        updateSummary() {
          const baseVariant = this.variants.find((variant) => Number(variant.id) === this.currentVariantId);
          let totalCents = Number(baseVariant?.price || 0);
          let selectedCount = 0;

          this.querySelectorAll('[data-bundle-item]').forEach((card) => {
            const toggle = card.querySelector('[data-addon-toggle]');
            const input = card.querySelector('[data-variant-input]');
            if (!toggle?.checked || !input || input.disabled) return;

            const option = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
            totalCents += Number(option.dataset.priceCents || input.dataset.priceCents || 0) * Number(input.dataset.quantity || 1);
            selectedCount += 1;
          });

          if (this.summary) {
            this.summary.textContent = selectedCount
              ? `${selectedCount} ${this.dataset.selectedSuffix}`
              : this.dataset.noExtrasLabel;
          }
          if (this.total) this.total.textContent = this.formatMoney(totalCents);
          this.updateDiscountProgress(selectedCount);
        }

        updateDiscountProgress(selectedCount) {
          if (!this.discountProgress) return;

          const remaining = Math.max(0, this.discountThreshold - selectedCount);
          const unlocked = remaining === 0;
          const progress = Math.min(100, (selectedCount / this.discountThreshold) * 100);
          const template = unlocked
            ? this.dataset.discountUnlockedLabel
            : remaining === 1
              ? this.dataset.discountRemainingLabel
              : this.dataset.discountRemainingPluralLabel;

          if (this.discountMessage) {
            this.discountMessage.textContent = String(template || '')
              .replaceAll('{count}', String(remaining))
              .replaceAll('{discount}', String(this.discountPercent));
          }
          if (this.discountBadge) this.discountBadge.textContent = `${this.discountPercent}% OFF`;
          if (this.discountFill) this.discountFill.style.width = `${progress}%`;
          this.discountProgress.classList.toggle('is-unlocked', unlocked);
        }

        formatMoney(cents) {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
              style: 'currency',
              currency: this.dataset.currency || 'USD'
            }).format(cents / 100);
          } catch (error) {
            return `$${(cents / 100).toFixed(2)}`;
          }
        }

        async addBundle() {
          if (!this.button || this.button.disabled || this.button.classList.contains('is-loading')) {
            return;
          }

          const rawItems = [{ id: this.currentVariantId, quantity: 1 }];
          this.querySelectorAll('[data-bundle-item]').forEach((card) => {
            const toggle = card.querySelector('[data-addon-toggle]');
            const input = card.querySelector('[data-variant-input]');
            if (toggle?.checked && input && !input.disabled && input.value) {
              rawItems.push({
                id: Number(input.value),
                quantity: Number(input.dataset.quantity || 1)
              });
            }
          });

          const combinedItems = new Map();
          rawItems.forEach((item) => {
            combinedItems.set(item.id, (combinedItems.get(item.id) || 0) + item.quantity);
          });
          const items = Array.from(combinedItems, ([id, quantity]) => ({ id, quantity }));

          if (items.length === 0) {
            this.showError(this.dataset.errorLabel);
            return;
          }

          this.button.classList.add('is-loading');
          this.button.disabled = true;
          this.status.textContent = '';
          this.status.classList.remove('is-error');
          this.button.querySelector('[data-button-text]').textContent = this.button.dataset.loadingLabel;

          try {
            const responses = [];

            for (const item of items) {
              const response = await fetch(this.dataset.addUrl, {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ items: [item] })
              });
              const data = await response.json();

              if (!response.ok) {
                throw new Error(data.description || data.message || this.dataset.errorLabel);
              }

              responses.push(data);
            }

            let cart = null;
            const cartResponse = await fetch(this.dataset.cartJsonUrl, {
              headers: { Accept: 'application/json' }
            });
            if (cartResponse.ok) cart = await cartResponse.json();

            this.button.classList.remove('is-loading');
            this.button.querySelector('[data-button-text]').textContent = this.button.dataset.successLabel;
            this.status.textContent = this.button.dataset.successLabel;

            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { source: 'compact-product-bundle', cart, responses }
              })
            );

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { source: 'compact-product-bundle', cart }
              })
            );

            if (this.dataset.redirect === 'true') {
              window.setTimeout(() => window.location.assign(this.dataset.cartUrl), 450);
            } else {
              window.setTimeout(() => {
                this.button.disabled = false;
                this.button.querySelector('[data-button-text]').textContent = this.button.dataset.defaultLabel;
              }, 1400);
            }
          } catch (error) {
            this.showError(error.message || this.dataset.errorLabel);
            this.button.classList.remove('is-loading');
            this.button.disabled = false;
            this.button.querySelector('[data-button-text]').textContent = this.button.dataset.defaultLabel;
          }
        }

        showError(message) {
          if (!this.status) {
            return;
          }

          this.status.textContent = message;
          this.status.classList.add('is-error');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marker-airbrush-conversion-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pjc3]').forEach((root) => {
      const mainImage = root.querySelector('.pjc3__main-image');
      const thumbs = root.querySelectorAll('[data-gallery-thumb]');
      const variantSelect = root.querySelector('[data-variant-select]');
      const variantButtons = root.querySelectorAll('[data-variant-button]');
      const price = root.querySelector('[data-product-price]');
      const mobilePrice = root.querySelector('[data-mobile-price]');
      const choiceTitle = root.querySelector('[data-choice-title]');
      const addButton = root.querySelector('[data-add-button]');
      const addLabel = root.querySelector('[data-add-label]');

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.removeAttribute('srcset');
          mainImage.src = thumb.dataset.image;
          mainImage.alt = thumb.dataset.alt || '';
          thumbs.forEach((item) => {
            item.classList.toggle('is-active', item === thumb);
            item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
          });
        });
      });

      variantButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const available = button.dataset.variantAvailable === 'true';
          if (!available || !variantSelect) return;
          variantSelect.value = button.dataset.variantId;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          variantButtons.forEach((item) => {
            item.classList.toggle('is-selected', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          if (price) price.textContent = button.dataset.variantPrice;
          if (mobilePrice) mobilePrice.textContent = button.dataset.variantPrice;
          if (choiceTitle) choiceTitle.textContent = button.dataset.variantTitle;
          if (addButton) addButton.disabled = false;
          if (addLabel) addLabel.textContent = root.dataset.addLabel || addLabel.textContent;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marker-airbrush-editorial-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupTabs = (root) => {
      if (root.dataset.mv2TabsReady === 'true') return;

      const tabs = Array.from(root.querySelectorAll('[data-mv2-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-mv2-panel]'));

      const activate = (key, moveFocus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.mv2Tab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.mv2Panel !== key;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.mv2Tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index && event.key !== 'Home' && event.key !== 'End') return;

          event.preventDefault();
          activate(tabs[nextIndex].dataset.mv2Tab, true);
        });
      });

      root.mv2Activate = activate;
      root.dataset.mv2TabsReady = 'true';
      activate('description');
    };

    document.querySelectorAll('[data-mv2-tabs]').forEach(setupTabs);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-mv2-tabs]').forEach(setupTabs);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-mv2-panel]');
      const root = panel && panel.closest('[data-mv2-tabs]');
      if (root && root.mv2Activate) root.mv2Activate(panel.dataset.mv2Panel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-image-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scrolling-image-cards')) {
    customElements.define(
      'scrolling-image-cards',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('.sic-viewport');
          this.track = this.querySelector('.sic-track');
          this.primaryGroup = this.querySelector('[data-primary-group]');
          this.toggle = this.querySelector('.sic-toggle');

          if (!this.viewport || !this.track || !this.primaryGroup || !this.primaryGroup.children.length) return;

          this.originalItems = Array.from(this.primaryGroup.children).map((item) => item.cloneNode(true));
          this.onToggle = () => {
            const isPaused = this.classList.toggle('is-paused');
            this.toggle.setAttribute('aria-pressed', String(isPaused));
            this.toggle.setAttribute('aria-label', isPaused ? 'Play scrolling' : 'Pause scrolling');
          };
          this.toggle.addEventListener('click', this.onToggle);

          this.rebuild();
          this.resizeObserver = new ResizeObserver(() => {
            cancelAnimationFrame(this.resizeFrame);
            this.resizeFrame = requestAnimationFrame(() => this.rebuild());
          });
          this.resizeObserver.observe(this.viewport);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.toggle?.removeEventListener('click', this.onToggle);
          cancelAnimationFrame(this.resizeFrame);
        }

        makeDecorative(item) {
          item.setAttribute('aria-hidden', 'true');
          item.removeAttribute('id');
          item.removeAttribute('data-shopify-editor-block');
          item.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          item.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
          return item;
        }

        rebuild() {
          this.track.querySelectorAll('[data-generated-copy]').forEach((copy) => copy.remove());
          this.primaryGroup.querySelectorAll('[data-generated-item]').forEach((item) => item.remove());

          let rounds = 0;
          const targetWidth = this.viewport.clientWidth + this.originalItems[0].getBoundingClientRect().width;

          while (this.primaryGroup.getBoundingClientRect().width < targetWidth && rounds < 20) {
            this.originalItems.forEach((original) => {
              const clone = this.makeDecorative(original.cloneNode(true));
              clone.setAttribute('data-generated-item', '');
              this.primaryGroup.appendChild(clone);
            });
            rounds += 1;
          }

          const secondGroup = this.primaryGroup.cloneNode(true);
          secondGroup.removeAttribute('data-primary-group');
          secondGroup.setAttribute('data-generated-copy', '');
          secondGroup.setAttribute('aria-hidden', 'true');
          secondGroup.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
            element.removeAttribute('data-shopify-editor-block');
          });
          secondGroup.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
          this.track.appendChild(secondGroup);
          this.style.setProperty('--sic-scroll-distance', `${this.primaryGroup.getBoundingClientRect().width}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('plamojet-gradient-tabs-v6')) {
    class PlamojetGradientTabsV6 extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.autoplay = this.dataset.autoplay === 'true';
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab, false));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.querySelectorAll('[data-video-toggle]').forEach((button) => {
          button.addEventListener('click', () => {
            const media = button.closest('.pjtv4__media');
            const video = this.getVisibleVideo(media);
            if (video) this.toggleVideo(video);
          });
        });

        this.querySelectorAll('video').forEach((video) => {
          video.addEventListener('click', () => this.toggleVideo(video));
          video.addEventListener('play', () => {
            this.syncMediaState(video.closest('.pjtv4__media'));
          });
          video.addEventListener('pause', () => {
            this.syncMediaState(video.closest('.pjtv4__media'));
          });
          video.addEventListener('ended', () => {
            this.syncMediaState(video.closest('.pjtv4__media'));
          });
        });

        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[role="tabpanel"]');
          const tab = panel
            ? this.tabs.find((item) => item.getAttribute('aria-controls') === panel.id)
            : null;
          if (tab) this.activate(tab, false);
        });

        this.onViewportChange = () => {
          const selectedTab =
            this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ||
            this.tabs[0];
          if (selectedTab) this.activate(selectedTab, false);
        };
        this.mobileQuery.addEventListener('change', this.onViewportChange);

        const selectedTab = this.tabs.find(
          (tab) => tab.getAttribute('aria-selected') === 'true'
        );
        if (selectedTab || this.tabs[0]) {
          this.activate(selectedTab || this.tabs[0], false);
        }
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.onViewportChange);
      }

      getPanelForTab(tab) {
        const panelId = tab?.getAttribute('aria-controls');
        if (!panelId) return null;
        return this.querySelector(`#${CSS.escape(panelId)}`);
      }

      getVisibleVideo(media) {
        if (!media) return null;
        const preferredDevice = this.mobileQuery.matches ? 'mobile' : 'desktop';
        const fallbackDevice = preferredDevice === 'mobile' ? 'desktop' : 'mobile';
        return (
          media.querySelector(`[data-device="${preferredDevice}"] video`) ||
          media.querySelector(`[data-device="${fallbackDevice}"] video`)
        );
      }

      toggleVideo(video) {
        if (video.paused) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        } else {
          video.pause();
        }
      }

      syncMediaState(media) {
        if (!media) return;

        const video = this.getVisibleVideo(media);
        const button = media?.querySelector('[data-video-toggle]');
        const playing = video ? !video.paused && !video.ended : false;

        media?.classList.toggle('is-playing', playing);
        if (!button) return;

        button.setAttribute(
          'aria-label',
          playing ? button.dataset.pauseLabel : button.dataset.playLabel
        );
      }

      activate(targetTab, focusTab = true) {
        const tab =
          typeof targetTab === 'number' ? this.tabs[targetTab] : targetTab;
        const activePanel = this.getPanelForTab(tab);
        if (!tab || !activePanel) return;

        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const selected = panel === activePanel;
          panel.hidden = !selected;
          panel.classList.toggle('is-entering', selected);

          const media = panel.querySelector('.pjtv4__media');
          const activeVideo = this.getVisibleVideo(media);
          const videos = Array.from(panel.querySelectorAll('video'));

          videos.forEach((video) => {
            if (selected && this.autoplay && video === activeVideo) {
              video.muted = true;
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
              return;
            }
            video.pause();
          });

          this.syncMediaState(media);
        });

        if (focusTab) tab.focus();
      }

      onKeydown(event, index) {
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        }
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === index) return;

        event.preventDefault();
        this.activate(nextIndex);
      }
    }

    customElements.define('plamojet-gradient-tabs-v6', PlamojetGradientTabsV6);
  }

  } catch(e) { console.error(e); }
})();
})();
